import { analog_bjt } from './analog_bjt';

export class bcp53mtwg extends analog_bjt {}
